import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'

const _0fd4f278 = () => interopDefault(import('../src/pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _511907d4 = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _2785c78d = () => interopDefault(import('../src/pages/sign_in.vue' /* webpackChunkName: "pages/sign_in" */))
const _2dec29a8 = () => interopDefault(import('../src/pages/google-calendar/callback.vue' /* webpackChunkName: "pages/google-calendar/callback" */))
const _6f1fe6a0 = () => interopDefault(import('../src/pages/initial-settings/company-profile.vue' /* webpackChunkName: "pages/initial-settings/company-profile" */))
const _35075744 = () => interopDefault(import('../src/pages/initial-settings/invite-members.vue' /* webpackChunkName: "pages/initial-settings/invite-members" */))
const _3becbef0 = () => interopDefault(import('../src/pages/initial-settings/user-profile.vue' /* webpackChunkName: "pages/initial-settings/user-profile" */))
const _515ab4b7 = () => interopDefault(import('../src/pages/sessions/branu-logout.vue' /* webpackChunkName: "pages/sessions/branu-logout" */))
const _5120989d = () => interopDefault(import('../src/pages/sessions/callback.vue' /* webpackChunkName: "pages/sessions/callback" */))
const _74910617 = () => interopDefault(import('../src/pages/sessions/callback-with-branu-user.vue' /* webpackChunkName: "pages/sessions/callback-with-branu-user" */))
const _cdb5d41e = () => interopDefault(import('../src/pages/sessions/invitation.vue' /* webpackChunkName: "pages/sessions/invitation" */))
const _5b09b372 = () => interopDefault(import('../src/pages/contents/_uuid/index.vue' /* webpackChunkName: "pages/contents/_uuid/index" */))
const _32c8461a = () => interopDefault(import('../src/pages/companies/_company_id/attendance-summary.vue' /* webpackChunkName: "pages/companies/_company_id/attendance-summary" */))
const _35bceb14 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds" */))
const _e24138b6 = () => interopDefault(import('../src/pages/companies/_company_id/construction-kinds/new.vue' /* webpackChunkName: "pages/companies/_company_id/construction-kinds/new" */))
const _599895b4 = () => interopDefault(import('../src/pages/companies/_company_id/customers.vue' /* webpackChunkName: "pages/companies/_company_id/customers" */))
const _9cb68376 = () => interopDefault(import('../src/pages/companies/_company_id/customers/new.vue' /* webpackChunkName: "pages/companies/_company_id/customers/new" */))
const _3498aca2 = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/index" */))
const _5a6a5a6a = () => interopDefault(import('../src/pages/companies/_company_id/customers/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/customers/_id/edit" */))
const _0c289d60 = () => interopDefault(import('../src/pages/companies/_company_id/expiration.vue' /* webpackChunkName: "pages/companies/_company_id/expiration" */))
const _c69ef390 = () => interopDefault(import('../src/pages/companies/_company_id/members.vue' /* webpackChunkName: "pages/companies/_company_id/members" */))
const _53bd7ec8 = () => interopDefault(import('../src/pages/companies/_company_id/profile.vue' /* webpackChunkName: "pages/companies/_company_id/profile" */))
const _16ab9feb = () => interopDefault(import('../src/pages/companies/_company_id/projects.vue' /* webpackChunkName: "pages/companies/_company_id/projects" */))
const _67456ba4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/index" */))
const _13251edc = () => interopDefault(import('../src/pages/companies/_company_id/projects/calendar.vue' /* webpackChunkName: "pages/companies/_company_id/projects/calendar" */))
const _2147b3c4 = () => interopDefault(import('../src/pages/companies/_company_id/projects/gantt-chart/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/gantt-chart/index" */))
const _3d29d4fc = () => interopDefault(import('../src/pages/companies/_company_id/projects/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/new" */))
const _7620561e = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/index" */))
const _32d05eb7 = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/devices-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/devices-allocation/index" */))
const _edec1ffc = () => interopDefault(import('../src/pages/companies/_company_id/projects/resource-allocation/member-allocation/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/resource-allocation/member-allocation/index" */))
const _29740016 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id" */))
const _3becc3ce = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/index" */))
const _60bdabb5 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/index" */))
const _179bc5f8 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/index" */))
const _0bc57048 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/card/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/card/index" */))
const _110596cc = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/detail.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/detail" */))
const _346c76b5 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/ledger/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/ledger/index" */))
const _355d4b3a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/member.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/member" */))
const _8ade9a6e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/index" */))
const _71d8a223 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/index" */))
const _606f0c6e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/summary.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/summary" */))
const _f523087a = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-list.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-list" */))
const _3a49fda6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/user-records.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/user-records" */))
const _e9d87b9e = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils" */))
const _ecb81500 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/attendance/utils/user-list.ts' /* webpackChunkName: "pages/companies/_company_id/projects/_id/attendance/utils/user-list" */))
const _64a16552 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/new.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/new" */))
const _5e4a1648 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/posts/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/posts/index" */))
const _45e29253 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/select-daily-reports.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/select-daily-reports" */))
const _528f768c = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/fullscreen" */))
const _0022e7d9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/preview" */))
const _474ff681 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/print/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/print/index" */))
const _8eb97932 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/index" */))
const _6e73cdf6 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/schedule/view/fullscreen.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/schedule/view/fullscreen" */))
const _c20b9030 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/index" */))
const _731c24e3 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/index" */))
const _d0b16338 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/edit" */))
const _e93e9060 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/board_posts/_board_id/files/index" */))
const _3b665609 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/edit" */))
const _82de8ace = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/files/_file_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/files/_file_id/preview" */))
const _22df5183 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/form.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/form" */))
const _031d18d9 = () => interopDefault(import('../src/pages/companies/_company_id/projects/_id/reports/_report_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/projects/_id/reports/_report_id/preview" */))
const _71e2183e = () => interopDefault(import('../src/pages/companies/_company_id/reports/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/index" */))
const _41dd57ef = () => interopDefault(import('../src/pages/companies/_company_id/setting.vue' /* webpackChunkName: "pages/companies/_company_id/setting" */))
const _d6e5d742 = () => interopDefault(import('../src/pages/companies/_company_id/sharing-contents/index.vue' /* webpackChunkName: "pages/companies/_company_id/sharing-contents/index" */))
const _836f7fa0 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/index" */))
const _d0470bb6 = () => interopDefault(import('../src/pages/companies/_company_id/unavailability.vue' /* webpackChunkName: "pages/companies/_company_id/unavailability" */))
const _c9821bd0 = () => interopDefault(import('../src/pages/companies/_company_id/user-profile.vue' /* webpackChunkName: "pages/companies/_company_id/user-profile" */))
const _aaa71d32 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/analytics/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/analytics/index" */))
const _1c8c3a78 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/index" */))
const _7399364c = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/index" */))
const _25892fb6 = () => interopDefault(import('../src/pages/companies/_company_id/skills-register/_member_id/index.vue' /* webpackChunkName: "pages/companies/_company_id/skills-register/_member_id/index" */))
const _99ce4ff0 = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/edit" */))
const _0cb6843a = () => interopDefault(import('../src/pages/companies/_company_id/files/_id/preview.vue' /* webpackChunkName: "pages/companies/_company_id/files/_id/preview" */))
const _d183e45e = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/ai_pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/ai_pdf" */))
const _f4861900 = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/edit.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/edit" */))
const _73363eec = () => interopDefault(import('../src/pages/companies/_company_id/reports/_id/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/reports/_id/pdf" */))
const _49b56054 = () => interopDefault(import('../src/pages/companies/_company_id/project/_id/schedule/pdf.vue' /* webpackChunkName: "pages/companies/_company_id/project/_id/schedule/pdf" */))
const _8acaa110 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

Vue.use(Router)

if (process.client) {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual'

    // reset scrollRestoration to auto when leaving page, allowing page reload
    // and back-navigation from other pages to use the browser to restore the
    // scrolling position.
    window.addEventListener('beforeunload', () => {
      window.history.scrollRestoration = 'auto'
    })

    // Setting scrollRestoration to manual again when returning to this page.
    window.addEventListener('load', () => {
      window.history.scrollRestoration = 'manual'
    })
  }
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected and scrollToTop is not explicitly disabled
  if (
    to.matched.length < 2 &&
    to.matched.every(r => r.components.default.options.scrollToTop !== false)
  ) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some(r => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise((resolve) => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}

export function createRouter() {
  return new Router({
    mode: 'history',
    base: decodeURI('/'),
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,

    routes: [{
      path: "/companies",
      component: _0fd4f278,
      name: "companies"
    }, {
      path: "/logout",
      component: _511907d4,
      name: "logout"
    }, {
      path: "/sign_in",
      component: _2785c78d,
      name: "sign_in"
    }, {
      path: "/google-calendar/callback",
      component: _2dec29a8,
      name: "google-calendar-callback"
    }, {
      path: "/initial-settings/company-profile",
      component: _6f1fe6a0,
      name: "initial-settings-company-profile"
    }, {
      path: "/initial-settings/invite-members",
      component: _35075744,
      name: "initial-settings-invite-members"
    }, {
      path: "/initial-settings/user-profile",
      component: _3becbef0,
      name: "initial-settings-user-profile"
    }, {
      path: "/sessions/branu-logout",
      component: _515ab4b7,
      name: "sessions-branu-logout"
    }, {
      path: "/sessions/callback",
      component: _5120989d,
      name: "sessions-callback"
    }, {
      path: "/sessions/callback-with-branu-user",
      component: _74910617,
      name: "sessions-callback-with-branu-user"
    }, {
      path: "/sessions/invitation",
      component: _cdb5d41e,
      name: "sessions-invitation"
    }, {
      path: "/contents/:uuid?",
      component: _5b09b372,
      name: "contents-uuid"
    }, {
      path: "/companies/:company_id/attendance-summary",
      component: _32c8461a,
      name: "companies-company_id-attendance-summary"
    }, {
      path: "/companies/:company_id/construction-kinds",
      component: _35bceb14,
      name: "companies-company_id-construction-kinds",
      children: [{
        path: "new",
        component: _e24138b6,
        name: "companies-company_id-construction-kinds-new"
      }]
    }, {
      path: "/companies/:company_id/customers",
      component: _599895b4,
      name: "companies-company_id-customers",
      children: [{
        path: "new",
        component: _9cb68376,
        name: "companies-company_id-customers-new"
      }, {
        path: ":id",
        component: _3498aca2,
        name: "companies-company_id-customers-id"
      }, {
        path: ":id/edit",
        component: _5a6a5a6a,
        name: "companies-company_id-customers-id-edit"
      }]
    }, {
      path: "/companies/:company_id/expiration",
      component: _0c289d60,
      name: "companies-company_id-expiration"
    }, {
      path: "/companies/:company_id/members",
      component: _c69ef390,
      name: "companies-company_id-members"
    }, {
      path: "/companies/:company_id/profile",
      component: _53bd7ec8,
      name: "companies-company_id-profile"
    }, {
      path: "/companies/:company_id/projects",
      component: _16ab9feb,
      children: [{
        path: "",
        component: _67456ba4,
        name: "companies-company_id-projects"
      }, {
        path: "calendar",
        component: _13251edc,
        name: "companies-company_id-projects-calendar"
      }, {
        path: "gantt-chart",
        component: _2147b3c4,
        name: "companies-company_id-projects-gantt-chart"
      }, {
        path: "new",
        component: _3d29d4fc,
        name: "companies-company_id-projects-new"
      }, {
        path: "resource-allocation",
        component: _7620561e,
        name: "companies-company_id-projects-resource-allocation"
      }, {
        path: "resource-allocation/devices-allocation",
        component: _32d05eb7,
        name: "companies-company_id-projects-resource-allocation-devices-allocation"
      }, {
        path: "resource-allocation/member-allocation",
        component: _edec1ffc,
        name: "companies-company_id-projects-resource-allocation-member-allocation"
      }, {
        path: ":id",
        component: _29740016,
        children: [{
          path: "",
          component: _3becc3ce,
          name: "companies-company_id-projects-id"
        }, {
          path: "attendance",
          component: _60bdabb5,
          name: "companies-company_id-projects-id-attendance"
        }, {
          path: "board_posts",
          component: _179bc5f8,
          name: "companies-company_id-projects-id-board_posts"
        }, {
          path: "card",
          component: _0bc57048,
          name: "companies-company_id-projects-id-card"
        }, {
          path: "detail",
          component: _110596cc,
          name: "companies-company_id-projects-id-detail"
        }, {
          path: "ledger",
          component: _346c76b5,
          name: "companies-company_id-projects-id-ledger"
        }, {
          path: "member",
          component: _355d4b3a,
          name: "companies-company_id-projects-id-member"
        }, {
          path: "reports",
          component: _8ade9a6e,
          name: "companies-company_id-projects-id-reports"
        }, {
          path: "schedule",
          component: _71d8a223,
          name: "companies-company_id-projects-id-schedule"
        }, {
          path: "attendance/summary",
          component: _606f0c6e,
          name: "companies-company_id-projects-id-attendance-summary"
        }, {
          path: "attendance/user-list",
          component: _f523087a,
          name: "companies-company_id-projects-id-attendance-user-list"
        }, {
          path: "attendance/user-records",
          component: _3a49fda6,
          name: "companies-company_id-projects-id-attendance-user-records"
        }, {
          path: "attendance/utils",
          component: _e9d87b9e,
          name: "companies-company_id-projects-id-attendance-utils",
          children: [{
            path: "user-list",
            component: _ecb81500,
            name: "companies-company_id-projects-id-attendance-utils-user-list"
          }]
        }, {
          path: "board_posts/new",
          component: _64a16552,
          name: "companies-company_id-projects-id-board_posts-new"
        }, {
          path: "board_posts/posts",
          component: _5e4a1648,
          name: "companies-company_id-projects-id-board_posts-posts"
        }, {
          path: "reports/select-daily-reports",
          component: _45e29253,
          name: "companies-company_id-projects-id-reports-select-daily-reports"
        }, {
          path: "schedule/fullscreen",
          component: _528f768c,
          name: "companies-company_id-projects-id-schedule-fullscreen"
        }, {
          path: "schedule/preview",
          component: _0022e7d9,
          name: "companies-company_id-projects-id-schedule-preview"
        }, {
          path: "schedule/print",
          component: _474ff681,
          name: "companies-company_id-projects-id-schedule-print"
        }, {
          path: "schedule/view",
          component: _8eb97932,
          name: "companies-company_id-projects-id-schedule-view"
        }, {
          path: "schedule/view/fullscreen",
          component: _6e73cdf6,
          name: "companies-company_id-projects-id-schedule-view-fullscreen"
        }, {
          path: "board_posts/:board_id",
          component: _c20b9030,
          name: "companies-company_id-projects-id-board_posts-board_id"
        }, {
          path: "files/:file_id",
          component: _731c24e3,
          name: "companies-company_id-projects-id-files-file_id"
        }, {
          path: "board_posts/:board_id/edit",
          component: _d0b16338,
          name: "companies-company_id-projects-id-board_posts-board_id-edit"
        }, {
          path: "board_posts/:board_id/files",
          component: _e93e9060,
          name: "companies-company_id-projects-id-board_posts-board_id-files"
        }, {
          path: "files/:file_id/edit",
          component: _3b665609,
          name: "companies-company_id-projects-id-files-file_id-edit"
        }, {
          path: "files/:file_id/preview",
          component: _82de8ace,
          name: "companies-company_id-projects-id-files-file_id-preview"
        }, {
          path: "reports/:report_id/form",
          component: _22df5183,
          name: "companies-company_id-projects-id-reports-report_id-form"
        }, {
          path: "reports/:report_id/preview",
          component: _031d18d9,
          name: "companies-company_id-projects-id-reports-report_id-preview"
        }]
      }]
    }, {
      path: "/companies/:company_id/reports",
      component: _71e2183e,
      name: "companies-company_id-reports"
    }, {
      path: "/companies/:company_id/setting",
      component: _41dd57ef,
      name: "companies-company_id-setting"
    }, {
      path: "/companies/:company_id/sharing-contents",
      component: _d6e5d742,
      name: "companies-company_id-sharing-contents"
    }, {
      path: "/companies/:company_id/skills-register",
      component: _836f7fa0,
      name: "companies-company_id-skills-register"
    }, {
      path: "/companies/:company_id/unavailability",
      component: _d0470bb6,
      name: "companies-company_id-unavailability"
    }, {
      path: "/companies/:company_id/user-profile",
      component: _c9821bd0,
      name: "companies-company_id-user-profile"
    }, {
      path: "/companies/:company_id/skills-register/analytics",
      component: _aaa71d32,
      name: "companies-company_id-skills-register-analytics"
    }, {
      path: "/companies/:company_id/files/:id?",
      component: _1c8c3a78,
      name: "companies-company_id-files-id"
    }, {
      path: "/companies/:company_id/reports/:id",
      component: _7399364c,
      name: "companies-company_id-reports-id"
    }, {
      path: "/companies/:company_id/skills-register/:member_id?",
      component: _25892fb6,
      name: "companies-company_id-skills-register-member_id"
    }, {
      path: "/companies/:company_id/files/:id?/edit",
      component: _99ce4ff0,
      name: "companies-company_id-files-id-edit"
    }, {
      path: "/companies/:company_id/files/:id?/preview",
      component: _0cb6843a,
      name: "companies-company_id-files-id-preview"
    }, {
      path: "/companies/:company_id/reports/:id/ai_pdf",
      component: _d183e45e,
      name: "companies-company_id-reports-id-ai_pdf"
    }, {
      path: "/companies/:company_id/reports/:id/edit",
      component: _f4861900,
      name: "companies-company_id-reports-id-edit"
    }, {
      path: "/companies/:company_id/reports/:id/pdf",
      component: _73363eec,
      name: "companies-company_id-reports-id-pdf"
    }, {
      path: "/companies/:company_id/project/:id?/schedule/pdf",
      component: _49b56054,
      name: "companies-company_id-project-id-schedule-pdf"
    }, {
      path: "/",
      component: _8acaa110,
      name: "index"
    }],

    fallback: false
  })
}
